import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FullWidthCTA } from "@cinch-labs/design-system";
import { useVehicleCount } from "@cinch-nx/search-shared";
import { ArticleHeader } from "@cinch-nx/landing-ui-articles";
import { renderWithResolver } from "@cinch-nx/landing-ui-shared";
import { EventNames, TrackingEventTypes, useAnalytics } from "@cinch-nx/shared-analytics";
import { Wrapper } from "@cinch-nx/shared-ui";
import { useRouter } from "next/router";
import { ArticlesPreview } from "./components";
import styles from "./guides-hub.module.css";
export const GuidesHubFeature = ({ content , recentArticleStories  })=>{
    const { vehicleCount  } = useVehicleCount();
    const router = useRouter();
    const numberOfCars = new Intl.NumberFormat("en-GB").format(vehicleCount ?? 0);
    const renderArticlesPreview = ()=>Object.entries(recentArticleStories).map(([key, articles])=>/*#__PURE__*/ _jsx(ArticlesPreview, {
                slug: key,
                articles: articles
            }, key));
    const { trackEvent  } = useAnalytics();
    const handleClick = ()=>{
        trackEvent({
            eventName: `Guides-  click search all cars button`,
            type: TrackingEventTypes.ADOBE,
            data: {
                event: {
                    name: EventNames.click,
                    category: "guides page",
                    label: "button in page",
                    action: "view all cars"
                }
            }
        });
        router.push("/used-cars");
    };
    return /*#__PURE__*/ _jsxs("article", {
        className: styles.page,
        "data-testid": `feature-article-${content.title}`,
        children: [
            /*#__PURE__*/ _jsxs(Wrapper, {
                isSlim: true,
                children: [
                    /*#__PURE__*/ _jsx(ArticleHeader, {
                        title: content.title,
                        subTitle: content.subtitle
                    }),
                    renderArticlesPreview()
                ]
            }),
            content.seoSection ? /*#__PURE__*/ _jsx(Wrapper, {
                isSlim: true,
                className: {
                    inner: styles.seoSection
                },
                children: renderWithResolver(content.seoSection)
            }) : null,
            /*#__PURE__*/ _jsx(FullWidthCTA, {
                iconName: "search",
                iconGradient: "galaxy",
                iconSize: 41,
                title: "Let’s find your next car",
                subtitle: "Ready to hit the open road?",
                buttonLabel: `Search all ${numberOfCars} cars`,
                onButtonClick: handleClick,
                className: styles.fullWidthCta
            })
        ]
    });
};
